import { useState } from 'react'
import { ShowWithImages } from 'types/Show'

import { ShowCardWizard } from './components/showCard'
import { WizardContainer } from './showList.style'

interface Props {
    data: ShowWithImages[]
    setIdOnClick: (id: string) => void
    initialSelectedId: string | null
}

export const ShowListWizard: React.FC<Props> = ({ data, setIdOnClick, initialSelectedId }: Props) => {
    const [selectedId, setSelectedId] = useState<string | null | undefined>(initialSelectedId)

    const handleCardClick = (id: string) => {
        setSelectedId(id)
        setIdOnClick(id)
    }

    return (
        <WizardContainer>
            {data.map((current) => (
                <ShowCardWizard key={current.show_id} data={current} onClick={handleCardClick} selected={current.show_id === selectedId} />
            ))}
        </WizardContainer>
    )
}
